export const DEFAULT_PERPAGE = 50

export const PERPAGE_CHOICES = [25, 50, 75, 100]

export const LABEL_PH = '...'
